
export class CountryCodes {
    public static CZECH_REPUBLIC: string = "CZ";
    public static DENMARK: string = "DK";
    public static NETHERLANDS: string = "NL";
    public static UK: string = "GB";
    public static USA: string = "US";
    public static FINLAND: string = "FI";
    public static FRANCE: string = "FR";
    public static GERMANY: string = "DE";
    public static HUNGARY: string = "HU";
    public static ITALY: string = "IT";
    public static JAPAN: string = "JP";
    public static NORTH_KOREA: string = "KP";
    public static SOUTH_KOREA: string = "KR";
    public static NORWAY: string = "NO";
    public static POLAND: string = "PL";
    public static PORTUGAL: string = "PT";
    public static BRAZIL: string = "BR";
    public static RUSSIA: string = "RU";
    public static CHINA: string = "CN";
    public static SPAIN: string = "ES";
    public static SWEDEN: string = "SE";
    public static TURKEY: string = "TR";
    public static GREECE: string = "GR";
    public static BULGARIA: string = "BG";
    public static ROMANIA: string = "RO";
    public static SLOVAKIA: string = "SK";
    public static TAIWAN: string = "TW";
    public static LITHUNIA: string = "LT";
    public static AUSTRALIA: string = "AU";

    public static INDIA: string = "IN";
    public static MEXICO: string = "MX";
    public static ARGENTINA: string = "AR";
    public static COLOMBIA: string = "CO";
    public static VENEZUELA: string = "VE";
    public static CHILE: string = "CL";

    public static EGYPT: string = "EG";
    public static SAUDI_ARABIA: string = "SA";
    public static UNITED_ARAB_EMIRATES: string = "AE";
    public static ARABIA: string = "ARAB";

    public static INTERNATIONAL: string = "XX";
}
